import { auth as authAPI } from './api.js';

/**
 * Client-side form validation
 */
export const validation = {
  /**
   * Validate email format
   */
  isValidEmail(email) {
    if (!email) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },

  /**
   * Validate username format
   */
  isValidUsername(username) {
    if (!username) return false;
    const usernameRegex = /^[a-zA-Z0-9_-]{3,50}$/;
    return usernameRegex.test(username);
  },

  /**
   * Validate password strength
   * Returns { valid: boolean, errors: string[] }
   */
  validatePassword(password) {
    const errors = [];

    if (!password) {
      return { valid: false, errors: ['Password is required'] };
    }

    if (password.length < 8) {
      errors.push('Password must be at least 8 characters');
    }

    if (!/[A-Z]/.test(password)) {
      errors.push('Password must contain at least one uppercase letter');
    }

    if (!/[a-z]/.test(password)) {
      errors.push('Password must contain at least one lowercase letter');
    }

    if (!/[0-9]/.test(password)) {
      errors.push('Password must contain at least one number');
    }

    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
      errors.push('Password must contain at least one special character');
    }

    return {
      valid: errors.length === 0,
      errors,
    };
  },
};

/**
 * Session management
 */
export const session = {
  /**
   * Check if user is authenticated
   */
  async checkAuth() {
    try {
      const user = await authAPI.getCurrentUser();
      return { authenticated: true, user };
    } catch (error) {
      return { authenticated: false, user: null };
    }
  },

  /**
   * Setup auto-logout timer (7 days)
   */
  setupAutoLogout() {
    const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

    // Check auth status periodically
    const checkInterval = setInterval(async () => {
      const { authenticated } = await this.checkAuth();
      if (!authenticated) {
        clearInterval(checkInterval);
        window.location.href = '/login.html';
      }
    }, 60 * 1000); // Check every minute

    // Auto logout after 7 days
    setTimeout(() => {
      authAPI.logout().then(() => {
        window.location.href = '/login.html';
      });
    }, SEVEN_DAYS_MS);
  },
};
